import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EfoEgiService } from './egi.service';
import { ElevationService } from './elevation.service';
import {
  RedmineIssue,
  RedmineIssuePost,
} from 'src/app/redmine-connect/redmine.interface';

@Injectable({
  providedIn: 'root',
})
export class RedmineService {
  constructor(
    private elevationService: ElevationService,
    private efoEgi: EfoEgiService,
  ) {}

  getProjects(): Observable<any> {
    return this.elevationService.getData('/redmine/projects');
  }

  getIssues(project?: number): Observable<RedmineIssue> {
    return this.elevationService.getData(`/redmine/issues/projects/${project}`);
  }

  getUsers(email): Observable<any> {
    return this.elevationService.getData(`/redmine/users?mail=${email}`);
  }

  getIssueStatuses(): Observable<any> {
    return this.elevationService.getData('/redmine/issue-statuses');
  }

  getTrackers(): Observable<any> {
    return this.elevationService.getData('/redmine/trackers');
  }

  getCustomFields(): Observable<any> {
    return this.elevationService.getData('/redmine/custom-fields');
  }

  getIssuePriorities(): Observable<any> {
    return this.elevationService.getData('/redmine/issue-priorities');
  }

  postIssue(formData: FormData): Observable<any> {
    return this.elevationService.postData('/redmine/issues', formData);
  }

  getGrowpodiumIssues(): Observable<any> {
    return this.efoEgi.getData('/rm/projects/growpodium/issues.json', {});
  }
}
